export const version = 'v2.2.4-2214-g7b080e046'
